import { Menu, MenuItem } from "@mui/material";
import { type FC } from "react";

import "./StatusSelect.scss";

interface StatusSelectProps {
  anchorEl: EventTarget | null;
  onSelect: (option: "NEW" | "ACTIVE" | "INACTIVE" | "LEGACY") => void;
  onClose?: () => void;
}

export const StatusSelect: FC<StatusSelectProps> = (props) => {
  const { onClose = () => { }, anchorEl = null, onSelect } = props;

  const handleChange = (value: "NEW" | "INACTIVE" | "ACTIVE" | "LEGACY") => {
    onSelect(value);
  };

  return (
    <Menu
      classes={{
        paper: "status-menu-container",
        list: "status-list-container",
      }}
      slotProps={{ paper: { sx: { borderRadius: "20px" } } }}
      onClose={onClose}
      open={!!anchorEl}
      anchorEl={anchorEl as HTMLElement}
      anchorOrigin={{
        horizontal: "center",
        vertical: "top",
      }}
      transformOrigin={{
        horizontal: "center",
        vertical: "bottom",
      }}
    >
      <MenuItem onClick={() => handleChange("NEW")} value="NEW">
        <div className="circle new"> </div>
        <p>חדש</p>
      </MenuItem>
      <MenuItem value="ACTIVE" onClick={() => handleChange("ACTIVE")}>
        <div className="circle active"> </div>
        <p>פעיל</p>
      </MenuItem>
      <MenuItem onClick={() => handleChange("INACTIVE")} value="INACTIVE">
        <div className="circle inactive"> </div>
        <p>לא פעיל</p>
      </MenuItem>
      <MenuItem onClick={() => handleChange("LEGACY")} value="LEGACY">
        <div className="circle legacy"> </div>
        <p>מאגר ישן</p>
      </MenuItem>
    </Menu>
  );
};
